// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var List = require("rescript/lib/js/list.js");
var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var JsxRuntime = require("react/jsx-runtime");
var RescriptReactRouter = require("@rescript/react/src/RescriptReactRouter.res.js");
var Utils$ReactHooksTemplate = require("../common/utils.res.js");
var Project$ReactHooksTemplate = require("./project.res.js");
var AlertComponent$ReactHooksTemplate = require("../common/AlertComponent.res.js");
var SurveyPageSearch$ReactHooksTemplate = require("./SurveyPageSearch.res.js");

var searchPlaceholder = "Search projects...";

function ProjectList$FolderIcon(props) {
  return JsxRuntime.jsx("svg", {
              children: JsxRuntime.jsx("path", {
                    d: "M1.5 4.5C1.5 3.67 2.17 3 3 3h3.17L7.5 4.5H13c.83 0 1.5.67 1.5 1.5v7c0 .83-.67 1.5-1.5 1.5H3c-.83 0-1.5-.67-1.5-1.5v-8z",
                    fill: "currentColor",
                    fillOpacity: props.active ? "0.35" : "0.15",
                    stroke: "currentColor",
                    strokeWidth: "1"
                  }),
              className: "text-pigmentblue",
              height: "16",
              width: "16",
              fill: "none",
              viewBox: "0 0 16 16"
            });
}

var FolderIcon = {
  make: ProjectList$FolderIcon
};

function ProjectList(props) {
  var setSelectedProject = props.setSelectedProject;
  var selectedProjectId = props.selectedProjectId;
  var projects = props.projects;
  var searchValue = props.searchValue;
  var match = React.useState(function (param) {
        return false;
      });
  var setclose = match[1];
  var selectedProjectId$p;
  if (selectedProjectId !== undefined) {
    selectedProjectId$p = selectedProjectId;
  } else if (projects) {
    var x = Project$ReactHooksTemplate.id(List.hd(projects));
    selectedProjectId$p = x !== undefined ? x : undefined;
  } else {
    selectedProjectId$p = undefined;
  }
  var filteredProjects = searchValue === "" ? projects : Belt_List.keep(projects, (function (project) {
            return Utils$ReactHooksTemplate.matchesSearchQuery(searchValue, Project$ReactHooksTemplate.name(project));
          }));
  return JsxRuntime.jsxs("div", {
              children: [
                props.alert && !match[0] ? JsxRuntime.jsx(AlertComponent$ReactHooksTemplate.make, {
                        alertType: {
                          TAG: "Failure",
                          _0: "Project not found!"
                        },
                        handleClose: (function (param) {
                            Curry._1(setclose, (function (param) {
                                    return true;
                                  }));
                          })
                      }) : JsxRuntime.jsx(JsxRuntime.Fragment, {}),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx(SurveyPageSearch$ReactHooksTemplate.make, {
                            value: searchValue,
                            onChange: props.onSearchChange,
                            searchPlaceholder: searchPlaceholder,
                            compact: true
                          }),
                      className: "p-4 border-b border-gray-200 flex-shrink-0"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsx("span", {
                            children: "Projects",
                            className: "text-10-px font-bold text-aurometalsaurus tracking-widest uppercase"
                          }),
                      className: "px-4 pt-4 pb-2 flex items-center justify-between flex-shrink-0"
                    }),
                JsxRuntime.jsx("div", {
                      children: Belt_List.length(filteredProjects) === 0 ? JsxRuntime.jsx("div", {
                              children: searchValue === "" ? "No projects found." : "No projects match your search.",
                              className: "px-3 py-6 text-center text-xs text-aurometalsaurus"
                            }) : $$Array.of_list(Belt_List.mapWithIndex(filteredProjects, (function (index, project) {
                                    var isActive = selectedProjectId$p === Project$ReactHooksTemplate.id(project);
                                    return JsxRuntime.jsxs("div", {
                                                children: [
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx(ProjectList$FolderIcon, {
                                                              active: isActive
                                                            }),
                                                        className: "mr-3 flex-shrink-0"
                                                      }),
                                                  JsxRuntime.jsx("div", {
                                                        children: JsxRuntime.jsx("p", {
                                                              children: Project$ReactHooksTemplate.name(project),
                                                              className: "text-sm truncate " + (
                                                                isActive ? "font-semibold text-pigmentblue" : "font-medium"
                                                              ),
                                                              title: Project$ReactHooksTemplate.name(project)
                                                            }),
                                                        className: "flex-1 min-w-0"
                                                      }),
                                                  JsxRuntime.jsx("span", {
                                                        children: String(Project$ReactHooksTemplate.surveyCount(project)),
                                                        className: "text-xs font-semibold ml-2 flex-shrink-0 min-w-5 h-5 px-1.5 rounded-full inline-flex items-center justify-center " + (
                                                          isActive ? "bg-pigmentblue text-white" : "bg-gray-100 text-darkcharcoal group-hover:bg-white group-hover:text-pigmentblue"
                                                        )
                                                      })
                                                ],
                                                className: "group flex items-center px-3 py-2.5 rounded-lg mb-1 cursor-pointer border transition-all duration-150 " + (
                                                  isActive ? "bg-ghostwhiteblue text-pigmentblue border-pigmentblue border-l-4 shadow-sm" : "text-darkcharcoal border-transparent hover:bg-pigmentblue hover:bg-opacity-10 hover:border-pigmentblue hover:border-opacity-25 hover:text-pigmentblue hover:shadow-sm"
                                                ),
                                                onClick: (function (param) {
                                                    Curry._1(setSelectedProject, (function (param) {
                                                            return project;
                                                          }));
                                                    var id = Project$ReactHooksTemplate.id(project);
                                                    var searchQuery = searchValue === "" ? "" : "search=" + searchValue + "&";
                                                    if (id !== undefined) {
                                                      return RescriptReactRouter.push("/projects/all?" + searchQuery + "selectedProjectId=" + String(id));
                                                    } else {
                                                      return RescriptReactRouter.push("/projects/all?" + searchQuery);
                                                    }
                                                  })
                                              }, String(index));
                                  }))),
                      className: "flex-1 min-h-0 overflow-y-auto px-2 pb-4"
                    }),
                JsxRuntime.jsx("div", {
                      children: JsxRuntime.jsxs("button", {
                            children: [
                              JsxRuntime.jsxs("svg", {
                                    children: [
                                      JsxRuntime.jsx("circle", {
                                            cx: "8",
                                            cy: "8",
                                            r: "7",
                                            stroke: "currentColor",
                                            strokeWidth: "1.5"
                                          }),
                                      JsxRuntime.jsx("path", {
                                            d: "M8 5v6M5 8h6",
                                            stroke: "currentColor",
                                            strokeLinecap: "round",
                                            strokeWidth: "1.5"
                                          })
                                    ],
                                    height: "16",
                                    width: "16",
                                    fill: "none",
                                    viewBox: "0 0 16 16"
                                  }),
                              "Add Project"
                            ],
                            className: "w-full flex items-center justify-center gap-2 py-3 rounded-lg bg-pigmentblue text-white text-sm font-semibold hover:bg-cetaceanblue transition-colors focus:outline-none focus:ring-2 focus:ring-pigmentblue focus:ring-offset-2",
                            type: "button",
                            onClick: props.toggleProjectCreate
                          }),
                      className: "flex-shrink-0 p-3 border-t border-gray-200"
                    })
              ],
              className: "projects-page-sidebar bg-white border-r border-gray-200 flex flex-col overflow-hidden"
            });
}

var make = ProjectList;

exports.searchPlaceholder = searchPlaceholder;
exports.FolderIcon = FolderIcon;
exports.make = make;
/* react Not a pure module */
